var map = {
	"./calculator-da.webp": "./src/assets/landing/calorie-deficit/calculator-da.webp",
	"./calculator-de.webp": "./src/assets/landing/calorie-deficit/calculator-de.webp",
	"./calculator-en.webp": "./src/assets/landing/calorie-deficit/calculator-en.webp",
	"./calculator-es-419.webp": "./src/assets/landing/calorie-deficit/calculator-es-419.webp",
	"./calculator-es.webp": "./src/assets/landing/calorie-deficit/calculator-es.webp",
	"./calculator-fr.webp": "./src/assets/landing/calorie-deficit/calculator-fr.webp",
	"./calculator-it.webp": "./src/assets/landing/calorie-deficit/calculator-it.webp",
	"./calculator-nb.webp": "./src/assets/landing/calorie-deficit/calculator-nb.webp",
	"./calculator-nl.webp": "./src/assets/landing/calorie-deficit/calculator-nl.webp",
	"./calculator-pl.webp": "./src/assets/landing/calorie-deficit/calculator-pl.webp",
	"./calculator-pt.webp": "./src/assets/landing/calorie-deficit/calculator-pt.webp",
	"./calculator-sv.webp": "./src/assets/landing/calorie-deficit/calculator-sv.webp",
	"./calculator-tr.webp": "./src/assets/landing/calorie-deficit/calculator-tr.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/landing/calorie-deficit sync recursive ^\\.\\/calculator\\-.*\\.webp$";